import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import GuideStyles from "assets/js/guide";

import "codemirror/lib/codemirror.css";
import "codemirror/theme/dracula.css";
import "codemirror/theme/material.css";

import "codemirror/theme/mdn-like.css";
import "codemirror/theme/the-matrix.css";
import "codemirror/theme/night.css";

import "codemirror/mode/xml/xml";
import "codemirror/mode/javascript/javascript";
import "codemirror/mode/css/css";

import "codemirror/addon/edit/closebrackets";
import "codemirror/addon/edit/closetag";
import { Controlled as ControlledEditor } from "react-codemirror2-react-17";

export default function GuideButton() {
  const [noticeExpanded, setNoticeExpanded] = useState();

  const handleNotice = panel => (event, newExpanded) => {
    setNoticeExpanded(newExpanded ? panel : false);
  };

  /* Accordion */
  const [expanded, setExpanded] = useState();
  const handleChange = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  /* Accordion */
  const [codemirror, setCodemirror] = useState();
  const handleCodemirror = panel => (event, newcodemirror) => {
    setCodemirror(newcodemirror ? panel : false);
  };

  return (
    <>
      <GuideStyles />
      <main id="main" className="container">
        <Box className="box-type-2" pb={0}>
          <div className="h-group">
            <h2 className="guide-h2">List</h2>
          </div>
        </Box>

        <Box className="box-type-6">
          <h3 className="guide-h3">Basic</h3>
        </Box>
        {/* ST : board-list basic */}
        <ul className="board-list">
          <li className="item">
            <Link to="">
              <div className="title-group">
                <p className="title ellipsis">
                  시각장애인용 테스트 전단 (1/12~1/18)
                </p>
                <i className="ico-new" />
              </div>
              <div className="board-info">
                <span className="date">2022.01.18</span>
                <span className="place">전체</span>
              </div>
            </Link>
          </li>
          <li className="item">
            <Link to="">
              <div className="title-group">
                <p className="title ellipsis">
                  시각장애인용 테스트 전단 활용방법에 대한 논의 시각장애인용
                  테스트 전단 활용방법에 대한 논의
                </p>
                <i className="ico-new" />
              </div>
              <div className="board-info">
                <span className="date">2022.01.18</span>
                <span className="place">전체</span>
              </div>
            </Link>
          </li>
          <li className="item">
            <Link to="">
              <div className="title-group">
                <p className="title ellipsis">
                  시각장애인용 테스트 전단 활용방법에 대한 논의 시각장애인용
                  테스트 전단 활용방법에 대한 논의
                </p>
              </div>
              <div className="board-info">
                <span className="date">2022.01.18</span>
                <span className="place">전체</span>
              </div>
            </Link>
          </li>
        </ul>
        {/* EN : board-list basic */}

        <Box className="box-type-6">
          <Accordion
            codemirror={codemirror === "boardList"}
            onChange={handleCodemirror("boardList")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`<ul className="board-list">
  <li className="item">
    <Link to="">
      <div className="title-group">
        <p className="title ellipsis">
          시각장애인용 테스트 전단 (1/12~1/18)
        </p>
        <i className="ico-new" />
      </div>
      <div className="board-info">
        <span className="date">2022.01.18</span>
        <span className="place">전체</span>
      </div>
    </Link>
  </li>
  <li className="item">
    <Link to="">
      <div className="title-group">
        <p className="title ellipsis">
          시각장애인용 테스트 전단 활용방법에 대한 논의 시각장애인용
          테스트 전단 활용방법에 대한 논의
        </p>
        <i className="ico-new" />
      </div>
      <div className="board-info">
        <span className="date">2022.01.18</span>
        <span className="place">전체</span>
      </div>
    </Link>
  </li>
  <li className="item">
    <Link to="">
      <div className="title-group">
        <p className="title ellipsis">
          시각장애인용 테스트 전단 활용방법에 대한 논의 시각장애인용
          테스트 전단 활용방법에 대한 논의
        </p>
      </div>
      <div className="board-info">
        <span className="date">2022.01.18</span>
        <span className="place">전체</span>
      </div>
    </Link>
  </li>
</ul>
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>
        </Box>

        <hr className="guide-hr" />

        <Box className="box-type-6">
          <h3 className="guide-h3">Accordion</h3>
        </Box>
        <Box className="box-type-6">
          <h4 className="guide-h4">FAQ</h4>
        </Box>
        <div className="board-list board-list-faq">
          <Accordion
            expanded={expanded === "panel1"}
            onChange={handleChange("panel1")}
            className="item"
          >
            <AccordionSummary
              aria-controls="panel1d-content"
              id="panel1d-header"
            >
              <p>
                구입한 물건을 교환 또는 환불하려고 하는데 어떻게 해야하나요?
              </p>
            </AccordionSummary>
            <AccordionDetails>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                eget. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                eget.
              </p>
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded === "panel2"}
            onChange={handleChange("panel2")}
            className="item"
          >
            <AccordionSummary
              aria-controls="panel2d-content"
              id="panel2d-header"
            >
              <p>메가포인트 적립 및 사용은 어떻게 하나요?</p>
            </AccordionSummary>
            <AccordionDetails>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                eget. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                eget.
              </p>
            </AccordionDetails>
          </Accordion>
        </div>

        <Box className="box-type-6">
          <Accordion
            codemirror={codemirror === "faq"}
            onChange={handleCodemirror("faq")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`<div className="board-list board-list-faq">
  <Accordion
    expanded={expanded === "panel1"}
    onChange={handleChange("panel1")}
    className="item"
  >
    <AccordionSummary
      aria-controls="panel1d-content"
      id="panel1d-header"
    >
      <p>
        구입한 물건을 교환 또는 환불하려고 하는데 어떻게 해야하나요?
      </p>
    </AccordionSummary>
    <AccordionDetails>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
        eget. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
        eget.
      </p>
    </AccordionDetails>
  </Accordion>
  <Accordion
    expanded={expanded === "panel2"}
    onChange={handleChange("panel2")}
    className="item"
  >
    <AccordionSummary
      aria-controls="panel2d-content"
      id="panel2d-header"
    >
      <p>메가포인트 적립 및 사용은 어떻게 하나요?</p>
    </AccordionSummary>
    <AccordionDetails>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
        eget. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
        eget.
      </p>
    </AccordionDetails>
  </Accordion>
</div>
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>
        </Box>

        <br />
        <br />

        <Box className="box-type-6">
          <h4 className="guide-h4">하단에 있는 Notice</h4>
        </Box>
        <Box className="notice is-bottom">
          <Accordion
            expanded={noticeExpanded === "notice"}
            onChange={handleNotice("notice")}
            className="item"
          >
            <AccordionSummary aria-controls="notice-content" id="notice-header">
              <p className="title">
                <i className="ico-noti" />
                유의사항
              </p>
            </AccordionSummary>
            <AccordionDetails>
              <ul className="list list-dot color-info font-14">
                <li>쿠폰번호 8자리를 입력해주세요</li>
                <li>등록된 쿠폰은 My 쿠폰함에서 바로 확인 가능합니다.</li>
                <li>쿠폰 등록 완료 후 취소는 불가능합니다.</li>
                <li>쿠폰 등록기간이 지나면 사용 불가합니다.</li>
              </ul>
            </AccordionDetails>
          </Accordion>
        </Box>

        <Box className="box-type-6">
          <Accordion
            codemirror={codemirror === "noticeIsBottom"}
            onChange={handleCodemirror("noticeIsBottom")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`<Box className="notice is-bottom">
  <Accordion
    expanded={noticeExpanded === "notice"}
    onChange={handleNotice("notice")}
    className="item"
  >
    <AccordionSummary aria-controls="notice-content" id="notice-header">
      <p className="title">
        <i className="ico-noti" />
        유의사항
      </p>
    </AccordionSummary>
    <AccordionDetails>
      <ul className="list list-dot color-info font-14">
        <li>쿠폰번호 8자리를 입력해주세요</li>
        <li>등록된 쿠폰은 My 쿠폰함에서 바로 확인 가능합니다.</li>
        <li>쿠폰 등록 완료 후 취소는 불가능합니다.</li>
        <li>쿠폰 등록기간이 지나면 사용 불가합니다.</li>
      </ul>
    </AccordionDetails>
  </Accordion>
</Box>
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>
        </Box>

        <hr className="guide-hr" />

        <Box className="box-type-6">
          <h3 className="guide-h3">Bullet - Dot</h3>

          <h4 className="guide-h4">Defalut - font size:16px</h4>
          <ul className="list list-dot">
            <li>쿠폰번호 8자리를 입력해주세요</li>
            <li>등록된 쿠폰은 My 쿠폰함에서 바로 확인 가능합니다.</li>
            <li>쿠폰 등록 완료 후 취소는 불가능합니다.</li>
            <li>쿠폰 등록기간이 지나면 사용 불가합니다.</li>
          </ul>

          <Accordion
            codemirror={codemirror === "listDot"}
            onChange={handleCodemirror("listDot")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`<ul className="list list-dot">
  <li>쿠폰번호 8자리를 입력해주세요</li>
  <li>등록된 쿠폰은 My 쿠폰함에서 바로 확인 가능합니다.</li>
  <li>쿠폰 등록 완료 후 취소는 불가능합니다.</li>
  <li>쿠폰 등록기간이 지나면 사용 불가합니다.</li>
</ul>
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>

          <br />

          <h4 className="guide-h4">font size:14px / color: #8E8E8E</h4>
          <ul className="list list-dot color-info font-14">
            <li>쿠폰번호 8자리를 입력해주세요</li>
            <li>등록된 쿠폰은 My 쿠폰함에서 바로 확인 가능합니다.</li>
            <li>쿠폰 등록 완료 후 취소는 불가능합니다.</li>
            <li>쿠폰 등록기간이 지나면 사용 불가합니다.</li>
          </ul>

          <Accordion
            codemirror={codemirror === "listDotFont14"}
            onChange={handleCodemirror("listDotFont14")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`<ul className="list list-dot color-info font-14">
  <li>쿠폰번호 8자리를 입력해주세요</li>
  <li>등록된 쿠폰은 My 쿠폰함에서 바로 확인 가능합니다.</li>
  <li>쿠폰 등록 완료 후 취소는 불가능합니다.</li>
  <li>쿠폰 등록기간이 지나면 사용 불가합니다.</li>
</ul>
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>

          <br />

          <h4 className="guide-h4">
            font size:16px / color: #8E8E8E /<br /> li + li: marginTop 10px
          </h4>
          <ul className="list list-dot color-info spacing-10">
            <li>
              회원탈퇴 후 재가입 시 신규회원으로 가입되며, 탈퇴전의 회원정보,
              주문정보, 결제수단 정보, 포인트 카드, 쿠폰은 복원되지 않습니다.
            </li>
            <li>
              부정 이용을 방지하기 위하여 사이트 정책에 따라 최대 30일 이내
              재가입이 불가합니다.
            </li>
            <li>
              진행 중인 주문/클레임, 정기배송 신청 건 등이 남아있는 경우는 해당
              사유가 해소된 이후 탈퇴가 가능합니다.
            </li>
            <li>
              개인정보는 재가입 유예기간 경과 후 즉시 파기됩니다. 단, 아래
              정보는 전자상거래법, 통신비밀보호법 등 관련 법령의 규정, 사이트의
              이용약관 및 개인정보 처리 방침에 의하여 일정기간 보관됩니다.
            </li>
          </ul>

          <Accordion
            codemirror={codemirror === "listDotFont16"}
            onChange={handleCodemirror("listDotFont16")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`<ul className="list list-dot color-info spacing-10">
  <li>
    회원탈퇴 후 재가입 시 신규회원으로 가입되며, 탈퇴전의 회원정보,
    주문정보, 결제수단 정보, 포인트 카드, 쿠폰은 복원되지 않습니다.
  </li>
  <li>
    부정 이용을 방지하기 위하여 사이트 정책에 따라 최대 30일 이내
    재가입이 불가합니다.
  </li>
  <li>
    진행 중인 주문/클레임, 정기배송 신청 건 등이 남아있는 경우는 해당
    사유가 해소된 이후 탈퇴가 가능합니다.
  </li>
  <li>
    개인정보는 재가입 유예기간 경과 후 즉시 파기됩니다. 단, 아래
    정보는 전자상거래법, 통신비밀보호법 등 관련 법령의 규정, 사이트의
    이용약관 및 개인정보 처리 방침에 의하여 일정기간 보관됩니다.
  </li>
</ul>
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>

          <br />

          <h4 className="guide-h4">
            font size:14px / color: #8E8E8E /<br /> li + li: marginTop 10px
          </h4>
          <ul className="list list-dot color-info font-14 spacing-10">
            <li>
              회원탈퇴 후 재가입 시 신규회원으로 가입되며, 탈퇴전의 회원정보,
              주문정보, 결제수단 정보, 포인트 카드, 쿠폰은 복원되지 않습니다.
            </li>
            <li>
              부정 이용을 방지하기 위하여 사이트 정책에 따라 최대 30일 이내
              재가입이 불가합니다.
            </li>
            <li>
              진행 중인 주문/클레임, 정기배송 신청 건 등이 남아있는 경우는 해당
              사유가 해소된 이후 탈퇴가 가능합니다.
            </li>
            <li>
              개인정보는 재가입 유예기간 경과 후 즉시 파기됩니다. 단, 아래
              정보는 전자상거래법, 통신비밀보호법 등 관련 법령의 규정, 사이트의
              이용약관 및 개인정보 처리 방침에 의하여 일정기간 보관됩니다.
            </li>
          </ul>

          <Accordion
            codemirror={codemirror === "listDotFont14Spacing10"}
            onChange={handleCodemirror("listDotFont14Spacing10")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`<ul className="list list-dot color-info font-14 spacing-10">
  <li>
    회원탈퇴 후 재가입 시 신규회원으로 가입되며, 탈퇴전의 회원정보,
    주문정보, 결제수단 정보, 포인트 카드, 쿠폰은 복원되지 않습니다.
  </li>
  <li>
    부정 이용을 방지하기 위하여 사이트 정책에 따라 최대 30일 이내
    재가입이 불가합니다.
  </li>
  <li>
    진행 중인 주문/클레임, 정기배송 신청 건 등이 남아있는 경우는 해당
    사유가 해소된 이후 탈퇴가 가능합니다.
  </li>
  <li>
    개인정보는 재가입 유예기간 경과 후 즉시 파기됩니다. 단, 아래
    정보는 전자상거래법, 통신비밀보호법 등 관련 법령의 규정, 사이트의
    이용약관 및 개인정보 처리 방침에 의하여 일정기간 보관됩니다.
  </li>
</ul>
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>

          <hr className="guide-hr" />

          <h3 className="guide-h3">Bullet - Number</h3>

          <ul className="list list-num">
            <li>
              "메가포인트 훼미리카드 회원(이하 "회원"이라 한다)" 이란 본 약관에
              동의하여 “회사”가 정한 자격 기준에 따라 가입한 “회원”을 말합니다.
            </li>
            <li>등록된 쿠폰은 My 쿠폰함에서 바로 확인 가능합니다.</li>
            <li>쿠폰 등록 완료 후 취소는 불가능합니다.</li>
            <li>쿠폰 등록기간이 지나면 사용 불가합니다.</li>
          </ul>

          <Accordion
            codemirror={codemirror === "listNum"}
            onChange={handleCodemirror("listNum")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`<ul className="list list-num">
  <li>
    "메가포인트 훼미리카드 회원(이하 "회원"이라 한다)" 이란 본 약관에
    동의하여 “회사”가 정한 자격 기준에 따라 가입한 “회원”을 말합니다.
  </li>
  <li>등록된 쿠폰은 My 쿠폰함에서 바로 확인 가능합니다.</li>
  <li>쿠폰 등록 완료 후 취소는 불가능합니다.</li>
  <li>쿠폰 등록기간이 지나면 사용 불가합니다.</li>
</ul>
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>

          <br />
          <br />

          <ul className="list list-num list-num-round">
            <li>
              "메가포인트 훼미리카드 회원(이하 "회원"이라 한다)" 이란 본 약관에
              동의하여 “회사”가 정한 자격 기준에 따라 가입한 “회원”을 말합니다.
            </li>
            <li>등록된 쿠폰은 My 쿠폰함에서 바로 확인 가능합니다.</li>
            <li>쿠폰 등록 완료 후 취소는 불가능합니다.</li>
            <li>쿠폰 등록기간이 지나면 사용 불가합니다.</li>
          </ul>

          <Accordion
            codemirror={codemirror === "listNumRound"}
            onChange={handleCodemirror("listNumRound")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`<ul className="list list-num list-num-round">
  <li>
    "메가포인트 훼미리카드 회원(이하 "회원"이라 한다)" 이란 본 약관에
    동의하여 “회사”가 정한 자격 기준에 따라 가입한 “회원”을 말합니다.
  </li>
  <li>등록된 쿠폰은 My 쿠폰함에서 바로 확인 가능합니다.</li>
  <li>쿠폰 등록 완료 후 취소는 불가능합니다.</li>
  <li>쿠폰 등록기간이 지나면 사용 불가합니다.</li>
</ul>
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>

          <br />
          <br />

          <ul className="list list-num font-14">
            <li>
              "메가포인트 훼미리카드 회원(이하 "회원"이라 한다)" 이란 본 약관에
              동의하여 “회사”가 정한 자격 기준에 따라 가입한 “회원”을 말합니다.
            </li>
            <li>등록된 쿠폰은 My 쿠폰함에서 바로 확인 가능합니다.</li>
            <li>쿠폰 등록 완료 후 취소는 불가능합니다.</li>
            <li>쿠폰 등록기간이 지나면 사용 불가합니다.</li>
          </ul>

          <Accordion
            codemirror={codemirror === "listNumFont14"}
            onChange={handleCodemirror("listNumFont14")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`<ul className="list list-num font-14">
  <li>
    "메가포인트 훼미리카드 회원(이하 "회원"이라 한다)" 이란 본 약관에
    동의하여 “회사”가 정한 자격 기준에 따라 가입한 “회원”을 말합니다.
  </li>
  <li>등록된 쿠폰은 My 쿠폰함에서 바로 확인 가능합니다.</li>
  <li>쿠폰 등록 완료 후 취소는 불가능합니다.</li>
  <li>쿠폰 등록기간이 지나면 사용 불가합니다.</li>
</ul>
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>

          <br />
          <br />

          <ul className="list list-num list-num-round font-14">
            <li>
              "메가포인트 훼미리카드 회원(이하 "회원"이라 한다)" 이란 본 약관에
              동의하여 “회사”가 정한 자격 기준에 따라 가입한 “회원”을 말합니다.
            </li>
            <li>등록된 쿠폰은 My 쿠폰함에서 바로 확인 가능합니다.</li>
            <li>쿠폰 등록 완료 후 취소는 불가능합니다.</li>
            <li>쿠폰 등록기간이 지나면 사용 불가합니다.</li>
          </ul>

          <Accordion
            codemirror={codemirror === "listNumRoundFont14"}
            onChange={handleCodemirror("listNumRoundFont14")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`<ul className="list list-num list-num-round font-14">
  <li>
    "메가포인트 훼미리카드 회원(이하 "회원"이라 한다)" 이란 본 약관에
    동의하여 “회사”가 정한 자격 기준에 따라 가입한 “회원”을 말합니다.
  </li>
  <li>등록된 쿠폰은 My 쿠폰함에서 바로 확인 가능합니다.</li>
  <li>쿠폰 등록 완료 후 취소는 불가능합니다.</li>
  <li>쿠폰 등록기간이 지나면 사용 불가합니다.</li>
</ul>
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>

          <br />
          <br />

          <ul className="list list-num list-num-round font-14 color-info">
            <li>
              "메가포인트 훼미리카드 회원(이하 "회원"이라 한다)" 이란 본 약관에
              동의하여 “회사”가 정한 자격 기준에 따라 가입한 “회원”을 말합니다.
            </li>
            <li>등록된 쿠폰은 My 쿠폰함에서 바로 확인 가능합니다.</li>
            <li>쿠폰 등록 완료 후 취소는 불가능합니다.</li>
            <li>쿠폰 등록기간이 지나면 사용 불가합니다.</li>
          </ul>

          <Accordion
            codemirror={codemirror === "listNumRoundFont14ColorInfo"}
            onChange={handleCodemirror("listNumRoundFont14ColorInfo")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`<ul className="list list-num list-num-round font-14 color-info">
  <li>
    "메가포인트 훼미리카드 회원(이하 "회원"이라 한다)" 이란 본 약관에
    동의하여 “회사”가 정한 자격 기준에 따라 가입한 “회원”을 말합니다.
  </li>
  <li>등록된 쿠폰은 My 쿠폰함에서 바로 확인 가능합니다.</li>
  <li>쿠폰 등록 완료 후 취소는 불가능합니다.</li>
  <li>쿠폰 등록기간이 지나면 사용 불가합니다.</li>
</ul>
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>

          <hr className="guide-hr" />

          <h3 className="guide-h3">Examples</h3>
          <Box className="notice">
            <p className="title">
              <i className="ico-noti" />
              유의사항
            </p>
            <ul className="list list-dot color-info font-14">
              <li>쿠폰번호 8자리를 입력해주세요</li>
              <li>등록된 쿠폰은 My 쿠폰함에서 바로 확인 가능합니다.</li>
              <li>쿠폰 등록 완료 후 취소는 불가능합니다.</li>
              <li>쿠폰 등록기간이 지나면 사용 불가합니다.</li>
            </ul>
          </Box>

          <Accordion
            codemirror={codemirror === "notice"}
            onChange={handleCodemirror("notice")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`<Box className="notice">
  <p className="title">
    <i className="ico-noti" />
    유의사항
  </p>
  <ul className="list list-dot color-info font-14">
    <li>쿠폰번호 8자리를 입력해주세요</li>
    <li>등록된 쿠폰은 My 쿠폰함에서 바로 확인 가능합니다.</li>
    <li>쿠폰 등록 완료 후 취소는 불가능합니다.</li>
    <li>쿠폰 등록기간이 지나면 사용 불가합니다.</li>
  </ul>
</Box>
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>
        </Box>

        <hr className="guide-hr" />

        <Box className="box-type-6">
          <h3 className="guide-h3">하단에 사용 - No Background</h3>
        </Box>
        <Box className="notice is-bottom">
          <p className="title">
            <i className="ico-noti" />
            유의사항
          </p>
          <ul className="list list-dot color-info font-14">
            <li>쿠폰번호 8자리를 입력해주세요</li>
            <li>등록된 쿠폰은 My 쿠폰함에서 바로 확인 가능합니다.</li>
            <li>쿠폰 등록 완료 후 취소는 불가능합니다.</li>
            <li>쿠폰 등록기간이 지나면 사용 불가합니다.</li>
          </ul>
        </Box>

        <Box className="box-type-6">
          <Accordion
            codemirror={codemirror === "noticeIsBottom"}
            onChange={handleCodemirror("noticeIsBottom")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`<Box className="notice is-bottom">
  <p className="title">
    <i className="ico-noti" />
    유의사항
  </p>
  <ul className="list list-dot color-info font-14">
    <li>쿠폰번호 8자리를 입력해주세요</li>
    <li>등록된 쿠폰은 My 쿠폰함에서 바로 확인 가능합니다.</li>
    <li>쿠폰 등록 완료 후 취소는 불가능합니다.</li>
    <li>쿠폰 등록기간이 지나면 사용 불가합니다.</li>
  </ul>
</Box>
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>
        </Box>

        <hr className="guide-hr" />

        <Box className="box-type-6">
          <h3 className="guide-h3">하단에 사용 - Background</h3>
        </Box>
        <Box className="notice is-bottom bg-grey">
          <p className="title">
            <i className="ico-noti" />
            유의사항
          </p>
          <ul className="list list-dot color-info font-14">
            <li>쿠폰번호 8자리를 입력해주세요</li>
            <li>등록된 쿠폰은 My 쿠폰함에서 바로 확인 가능합니다.</li>
            <li>쿠폰 등록 완료 후 취소는 불가능합니다.</li>
            <li>쿠폰 등록기간이 지나면 사용 불가합니다.</li>
          </ul>
        </Box>

        <Box className="box-type-6">
          <Accordion
            codemirror={codemirror === "noticeIsBottomBgGrey"}
            onChange={handleCodemirror("noticeIsBottomBgGrey")}
            className="accordion-codemirror"
          >
            <AccordionSummary>
              <p>코드보기</p>
            </AccordionSummary>
            <AccordionDetails>
              <ControlledEditor
                value={`<Box className="notice is-bottom bg-grey">
  <p className="title">
    <i className="ico-noti" />
    유의사항
  </p>
  <ul className="list list-dot color-info font-14">
    <li>쿠폰번호 8자리를 입력해주세요</li>
    <li>등록된 쿠폰은 My 쿠폰함에서 바로 확인 가능합니다.</li>
    <li>쿠폰 등록 완료 후 취소는 불가능합니다.</li>
    <li>쿠폰 등록기간이 지나면 사용 불가합니다.</li>
  </ul>
</Box>
              `}
                className="code-mirror-wrapper"
                options={{
                  lineWrapping: true,
                  lint: true,
                  mode: "xml",
                  theme: "material",
                  lineNumbers: true,
                }}
              />
            </AccordionDetails>
          </Accordion>
        </Box>
      </main>
    </>
  );
}
